import { RefreshCw } from 'lucide-react';
import { useNewVersionAvailable } from '@/lib/appVersion/newVersion';

/** QA-577 — 새 백오피스가 배포되면 화면 위에 새로고침 안내(예전 코드로 조회해 결과가 달라 보이는 것 방지). */
export const NewVersionBanner = () => {
  const available = useNewVersionAvailable();
  if (!available) return null;
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-center gap-3 px-4 py-2 text-[13px]"
      style={{ background: 'var(--status-warn-bg)', color: 'var(--status-warn-fg)' }}
      data-testid="new-version-banner"
    >
      <span>새 버전의 백오피스가 배포되었습니다. 최신 화면과 조회 결과를 보려면 새로고침해 주세요.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="inline-flex items-center gap-1 rounded-md border px-2 py-0.5 font-medium"
        style={{ borderColor: 'currentColor' }}
      >
        <RefreshCw size={13} aria-hidden="true" />
        새로고침
      </button>
    </div>
  );
};
